module.exports = __webpack_public_path__ + "fonts/Muli-Regular.df733025.ttf";